import { buildSlice, CommonState } from '~libs/reduxUtils';

import { ClientBudgetStatus } from '~support-at-home/models';

import { getAll, getOne, typePrefix } from '~support-at-home/actions/clientBudgetStatuses';

const initialState: CommonState<ClientBudgetStatus> = {
  loading: 'idle',
  hasLoaded: false,
  error: null,
  rows: [],
};

const slice = buildSlice<CommonState<ClientBudgetStatus>, ClientBudgetStatus>(typePrefix, initialState, {
  commonConfig: { getAll, getOne },
});

export const { clear } = slice.actions;
export default slice.reducer;
